import SelectEmailTemplateTable from "./SelectEmailTemplateTable";
import EditMailContent from "./EditMailContent";

// import React, { useCallback, useEffect, useState, useRef } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import {
//     Box,
//     Button,
//     Chip,
//     formControlClasses,
//     Input,
//     Paper,
//     TextField,
//     Typography,
//     Switch,
//     FormControlLabel,
//     ToggleButton,
//     ToggleButtonGroup,
//     Divider,
// } from "@mui/material";
// import { InputAdornment } from "@mui/material";
// import {
//     ChevronLeft,
//     NavigateNextSharp,
//     SubjectSharp,
//     Upload,
// } from "@mui/icons-material";
// import Editor from "./Editor";
// import CustomizedSteppers from "./CustomizedSteppers";
// import FileTable from "./FileTable";
// import NoticeBox from "./NoticeBox";
// import UploadFiles from "./UploadFiles";
// import axiosInstance from "../../api/axiosInstance";
// import useNotification from "../common/Notification";
// import isValidate from "../../utils/validation";

// import { csvFilePoints, bulletPoints } from "../../utils/constants";
// import debounce from "../../utils/debounce";
// import ScheduleDialog from "./ScheduleDialog";
// import CustomizedDrawer from "./CustomizedDrawer";
// import { CircularProgress } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import SelectEmailTemplate from "./SelectEmailTemplate";
// import { teal } from "@mui/material/colors";
// import EmailEditorTest from "./EmailEditorTest";

// const EmailSchedule = () => {
//     const [subject, setSubject] = useState("");
//     const [currentStep, setCurrentStep] = useState(0);
//     const [files, setFiles] = useState([]);
//     const [emailFile, setEmailFile] = useState([]);
//     const [isAttachedFiles, setIsAttachedFiles] = useState(true);
//     const [attachmentIds, setAttachmentIds] = useState([]);
//     const [eci, setEci] = useState(null);
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [editorContent, setEditorContent] = useState("");
//     const [backdropOpen, setBackdropOpen] = useState(false);
//     const [skip, setSkip] = useState(true);
//     const [manualEmail, setManualEmail] = useState("");
//     const [saveLoading, setSaveLoading] = useState(false);
//     const [enableHTML, setEnableHTML] = useState(false); // HTML toggle
//     const [editorMode, setEditorMode] = useState("raw");

//     const editorRef = useRef(null);
    
//     // const [open, setOpen] = useState(true);
//     const [date, setDate] = useState("");
//     const notify = useNotification();
//     const navigate = useNavigate();
//   const [selectedPriority, setSelectedPriority] = useState(null);

//     // Generate 10 priority chips with decreasing opacity
//     const priorityChips = Array.from({ length: 10 }, (_, index) => {
//         const priorityNumber = index + 1;
//         const opacity = 1 - (index * 0.09); // Decreasing opacity from 1 to 0.1
//         const backgroundColor = `rgba(0, 128, 128, ${opacity})`
//         return {
//             priorityNumber,
//             opacity,
//             backgroundColor,
//             label: `Priority ${priorityNumber}`
//         };
//     });

//     const handlePriorityClick = (priorityNumber) => {
//         setSelectedPriority(priorityNumber);
//     };
//     useEffect(() => {
//         if (files.length === 0) {
//             setSkip(true);
//         }
//     }, [files]);


//   const handleModeChange = (event, newMode) => {
//     console.log("Selected Mode : ", newMode);
//     if (newMode !== null) {
//       setEditorMode(newMode);
//     }
//   };


//     //Back button alert with useEffect

//     useEffect(() => {
//         const handlePopState = (event) => {
//             const confirmed = window.confirm(
//                 "Unsaved data will be lost if you go back."
//             );
//             if (!confirmed) {
//                 // Push the current URL again to cancel the back navigation
//                 window.history.pushState(null, "", window.location.pathname);
//             }
//         };

//         // Add a fake history entry so the user can "go back"
//         window.history.pushState(null, "", window.location.pathname);

//         window.addEventListener("popstate", handlePopState);

//         return () => {
//             window.removeEventListener("popstate", handlePopState);
//         };
//     }, []);

//     //Api functionns
//     //Attaching files api

//     const handleUploadAttachments = async () => {
//         try {
//             if (files.length === 0) {
//                 return;
//             }

//             let totalFileSizeArr = files.map((file) =>
//                 parseFloat((file.size / 1024).toFixed(1))
//             );

//             let totalFileSize = 0;
//             totalFileSizeArr.forEach((num) => {
//                 totalFileSize += num;
//             });

//             console.log(totalFileSize);

//             if (totalFileSize > 25600) {
//                 notify("Total file size exceeded 25 mb.", "error");
//                 return;
//             }

//             const payload = new FormData();
//             files.forEach((file) => {
//                 payload.append("attachments[]", file);
//             });

//             setBackdropOpen(true);

//             const res = await axiosInstance.post(
//                 "/upload/email/attachments",
//                 payload
//             );
//             notify("Files have been uploaded successfully.", "success");
//             if (res.data?.attachment_ids.length > 0) {
//                 const ids = res.data.attachment_ids;
//                 setAttachmentIds([...ids]);
//             }

//             console.log(res);
//         } catch (e) {
//             if (e.status == 409) {
//                 notify(`${e.response?.data?.message}`, "error");
//                 return;
//             }

//             if (e.status === 413) {
//                 notify(`${e.response?.data.message}`, "error");
//                 return;
//             }
//             if (e.status === 422) {
//                 notify(`${e.response?.data.message}`, "error");
//                 return;
//             }
//             notify(`${e.message}`, "error");
//             console.log("Error: ", e);
//         } finally {
//             // loading ended
//             setBackdropOpen(false);
//         }
//     };

//     // Subject change function *******************************************************************
//     // const debouncedSetSubject = useCallback(
//     //     debounce((value) => setSubject(value), 50),
//     //     []
//     // );

//     const handleSubjectChange = (e) => {
//         const value = e.target.value;
//         setSubject(e.target.value);

//         // debouncedSetSubject(e.target.value);
//     };

//     console.log(subject);

//     //Step change functions **********************************************************************
//     const handleNextStep = () => {

//         if (currentStep === 0) {
//     if (editorMode === "advanced") {
//       editorRef.current.exportHtml((html) => {
//         const content = html.trim();

//         if (!isValidate("subject", subject.trim()) || !isValidate("editorContent", content)) {
//           notify("Some fields are missing.", "error");
//           return;
//         }

//         setEditorContent(content); // async, but we already validated using `content`
//         console.log("Advanced HTML saved:", content);

//         // Move to next step safely
//         setCurrentStep((prev) => prev + 1);
//       });
//       return; // stop here since next step handled inside callback
//     }

//     // for simple or raw editors
//     if (!isValidate("subject", subject.trim()) || !isValidate("editorContent", editorContent.trim())) {
//       notify("Some fields are missing.", "error");
//       return;
//     }
//   }


//         // if (currentStep === 1) {
//         //     setIsAttachedFiles(true);
//         // }

//         if (currentStep === 2) {
//             setIsAttachedFiles(false);
//         }

//         if (currentStep === 1) {
//             if (!skip) {
//                 if (files.length > 0 && attachmentIds.length === 0) {
//                     notify("Attachments are not uploaded correctly.", "error");
//                     return;
//                 }
//                 if (!eci) {
//                     notify("Content is not saved properly", "error");
//                     return;
//                 }
//             }

//             if (!eci) {
//                 notify("Content is not saved properly", "error");
//                 return;
//             }
//         }
//         if (currentStep < 2) {
//             setCurrentStep((prev) => prev + 1);
//         }
//         return;
//     };

//     const handleBackStep = () => {
//         if (currentStep > 0) {
//             setCurrentStep((prev) => prev - 1);
//         }
//         return;
//     };

//     // Files functions **************************************************************************
//     const handleAttachedFiles = (e) => {
//         const selectedFiles = e.target?.files;
//         if (!selectedFiles) {
//             return;
//         }
//         const length1 = selectedFiles.length;
//         const length2 = files.length;
//         const totalLength = length1 + length2;

//         if (selectedFiles.length > 5 || totalLength > 5) {
//             notify("Cannot Attach more than 5 files.", "error");
//             return;
//         }

//         setFiles((prev) => [...prev, ...e.target.files]);
//         setSkip(false);
//         console.log(e.target.files);
//     };

//     // const handleAttachSingleFile = (e) => {
//     //     const files = e.target?.files;
//     //     if (!files) {
//     //         return;
//     //     }
//     //     // if(files.)
//     // };

//     const onDelete = (idx) => {
//         setFiles((prev) => prev.filter((_, i) => i != idx));
//         console.log("deleting...");
//     };

//     const handleEditFiles = (e, idx) => {
//         const file = e.target?.files[0];
//         if (!file) return;

//         setFiles((prev) =>
//             prev.map((file, i) => {
//                 if (i === idx) {
//                     console.log(e.target.files);
//                     return e.target.files[0];
//                 }
//                 return file;
//             })
//         );

//         notify("File has been replaced.", "success");
//     };

//     // Email file attachment function *************************************************************
//     const handleEmailAttach = (e) => {
//         const file = e.target?.files;
//         if (!file) return;

//         console.log(file);
//         setEmailFile([...file]);
//     };

//     const handleCsvFileEdit = (e, i) => {
//         const file = e.target?.files;
//         if (!file) return;

//         setEmailFile((prev) => [...file]);
//     };

//     const handleDeleteCsv = (i) => {
//         setEmailFile([]);
//     };
//     const convertTime = (seconds) => {
//         const hrs = Math.floor(seconds / 3600);
//         const mins = Math.floor((seconds % 3600) / 60);
//         const secs = seconds % 60;

//         return `${hrs}h ${mins}m ${secs}s`;
//     };

//     // const handleScheduleLater = () => {};
//     const handleFinalSubmit = async () => {
//         if (manualEmail) {
//             if (!eci) {
//                 notify("Email content has not been saved.", "error");
//                 return;
//             }
//             if (!date) {
//                 notify("Schedule date is not added", "error");
//                 return;
//             }
//             const payload = {
//                 eci: eci,
//                 schedule_date_time: date,
//                 email: manualEmail,
//                 message_priority:selectedPriority
//             };
//             console.log("Payload: ", payload)
//             try {
//                 const res = await axiosInstance.post(
//                     `/upload/emails-manual`,
//                     payload
//                 );

//                 const time = 15;
//                 const count = res.data.data;
//                 console.log(res.data.data);
//                 const estimatedTime = convertTime(15 * count);

//                 notify(
//                     `Email(s) have been queued , Estimated time would be ${estimatedTime}. Redirecting to Email queue in 5 sec... `,
//                     "success"
//                 );
//                 setTimeout(() => {
//                     navigate("/email-queue");
//                 }, 5000);
//                 console.log(res);
//             } catch (e) {
//                 if (e.status == 422) {
//                     console.log(e.response.data);
//                     // return;
//                 }
//                 console.log("Error: ", e);
//                 notify(`${e.response.data.message}`, "error");
//                 let result;
//                 if (e.response.data?.invalid_emails) {
//                     const myArray = e.response.data?.invalid_emails;
//                     result = myArray.join(", ");
//                 }
//                 notify(`${result}`, "error");
//             }
//         } else {
//             try {
//                 const payload = new FormData();
//                 if (emailFile.length === 0) {
//                     notify("Email file not uploaded.", "error");
//                     return;
//                 }
//                 if (!date) {
//                     notify("Please Select date and time.", "error");
//                     return;
//                 }
//                 if (!eci) {
//                     notify("Something went wrong , please try again", "error");
//                     // setCurrentStep(0);
//                     return;
//                 }

//                 payload.append("file", emailFile[0]);
//                 payload.append("eci", eci);
//                 payload.append("schedule_date_time", date);
//                 setBackdropOpen(true);
//                 const res = await axiosInstance.post("/upload/emails", payload);
//                 const time = 15;
//                 const count = res.data.emails_count;
//                 const estimatedTime = convertTime(15 * count);

//                 notify(
//                     `Emails have been queued , Estimated time would be ${estimatedTime}. Redirecting to Email queue in 5 sec... `,
//                     "success"
//                 );
//                 setTimeout(() => {
//                     navigate("/email-queue");
//                 }, 5000);
//                 // console.log(res);
//             } catch (e) {
//                 console.error("Error: ", e);
//                 notify("Something went wrong, please try again.", "error");
//             } finally {
//                 setBackdropOpen(false);
//             }
//         }
//     };

//     // Saving email content in database
//     const handleSaveContent = async () => {
//         try {
//             if (skip) {
//                 setDrawerOpen(true);
//                 return;
//             }
//             if (!subject) {
//                 notify("Subject is missing.", "error");
//                 return;
//             }
//             if (!editorContent) {
//                 notify("Email content is missing", "error");
//                 return;
//             }
//             if (!skip) {
//                 if (attachmentIds.length === 0) {
//                     notify("Please upload file attachment(s).", "error");
//                     return;
//                 }
//             }

//             const newAttachmentId = attachmentIds.join(",");
//             const payload = {
//                 subject: subject,
//                 content: editorContent,
//                 attachment_id: newAttachmentId,
//             };
//             setSaveLoading(true);
//             const res = await axiosInstance.post(
//                 "/emails/content-add",
//                 payload
//             );
//             console.log(res);
//             console.log(payload);
//             setEci(res.data.id);
//             notify("Content has been saved!", "success");
//             setCurrentStep(2);
//         } catch (e) {
//             console.error("Error: ", e);
//             notify("Error while saving content, please try again.", "error");
//         } finally {
//             //
//             setSaveLoading(false);
//         }
//     };

//     const saveContent = async () => {
//         try {
//             if (!subject) {
//                 notify("Subject is missing.", "error");
//                 return;
//             }
//             if (!editorContent) {
//                 notify("Email content is missing", "error");
//                 return;
//             }
//             const newAttachmentId = attachmentIds.join(",");
//             const payload = {
//                 subject: subject,
//                 content: editorContent,
//                 attachment_id: null,
//             };
//             const res = await axiosInstance.post(
//                 "/emails/content-add",
//                 payload
//             );
//             console.log(res);
//             console.log(payload);
//             setEci(res.data.id);
//             setCurrentStep(2);
//             notify("Email Content has been saved.", "success");
//         } catch (e) {
//             console.error("Error: ", e);
//         } finally {
//             //
//         }
//     };

//     // Drawer close and call handle save content function
//     const closeDrawer = async () => {
//         console.log("Function is called...");
//         setDrawerOpen(false);
//         console.log(drawerOpen);
//         saveContent();

//         // handleSaveContent();
//     };

//     // Function to handle manual emails
//     const handleManualEmailChange = (e) => {
//         setManualEmail(e.target.value);
//         console.log(e.target.value);
//     };

//     //Function to schedule time for manual emails added
//     const handleManualEmailAdd = () => {};

//       const handleTemplateSelect = ({ subject, content }) => {
//     setSubject(subject);         // Auto-fill subject
//     setEditorContent(content);   // Auto-fill editor
//   };

//   const handleAdvancedEditorContent = (html)=> {
//     console.log("Advanced Editor Content:", html);
//     setEditorContent(html);
//   }
  
//     return (
//         <Box
//             sx={{
//                 height: "100%",
//                 width: "100%",
//                 marginTop: "1.5rem",
//                 // bgcolor: "yellow",
//                 // padding: 2,
//             }}
//         >
//             <Box sx={{ width: "100%", display: "flex", mb: 1 }}>
//                 <Box
//                     sx={{
//                         width: "100%",
//                         height: "4rem",
//                         // bgcolor: "violet",
//                     }}
//                 >
//                     <CustomizedSteppers currentStep={currentStep} />
//                 </Box>
//             </Box>
//             <Box sx={{ height: "100%", width: "100%", display: "flex" }}>
//                 {currentStep === 0 && (
//                     <Box
//                         style={{
//                             height: "100%",

//                             width: "100%",
//                         }}
//                     >   
//                     <SelectEmailTemplate  onTemplateSelect={handleTemplateSelect} onMessageChange={handleNextStep}/>

//       <Typography variant="subtitle1" sx={{ mb: 1 }}>
//         Editor Mode
//       </Typography>

//       <ToggleButtonGroup
//         value={editorMode}
//         exclusive
//         onChange={handleModeChange}
//         color="primary"
//       >
//         <ToggleButton value="raw">Raw HTML</ToggleButton>
//         <ToggleButton value="simple">Simple Editor</ToggleButton>
//         {/* <ToggleButton value="advanced">Advanced Editor</ToggleButton> */}
//       </ToggleButtonGroup>

//       <Divider sx={{ my: 3 }} />
    
//                         <Box
//                             sx={{
//                                 width: "100%",
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 mb: 1,
//                             }}
//                         >
//                             <TextField
//                                 variant="outlined"
//                                 label="Subject"
//                                 placeholder="Type subject here..."
//                                 value={subject}
//                                 onChange={handleSubjectChange}
//                                 required
//                                 size="small"
//                                 sx={{ width: "100%" }}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SubjectSharp color="action" />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                             />
//                         </Box>
//             { editorMode === "raw" && (                       
                                           
//                         <Box sx={{ display: "flex", gap: 2 }}>
//                                   {/* Left: Textarea for HTML */}
//                                   <textarea
//                                     value={editorContent}
//                                     onChange={(e) =>
//                                       setEditorContent(e.target.value)
//                                     }
//                                     style={{
//                                       width: "50%",
//                                       height: "25rem",
//                                       padding: "1rem",
//                                       fontFamily: "monospace",
//                                       fontSize: "0.9rem",
//                                       border: "1px solid #ccc",
//                                       borderRadius: 4,
//                                     }}
//                                     placeholder="Paste your HTML content here"
//                                   />
                        
//                                   {/* Right: Live Preview */}
//                                   <Box
//                                     sx={{
//                                       width: "50%",
//                                       height: "25rem",
//                                       border: "1px solid #ccc",
//                                       borderRadius: 2,
//                                       p: 2,
//                                       overflow: "auto",
//                                       backgroundColor: "#fafafa",
//                                     }}
//                                     dangerouslySetInnerHTML={{
//                                       // __html: DOMPurify.sanitize(template.template),
//                                       __html:editorContent,
                        
//                                     }}
//                                   />
//                         </Box>)} { editorMode === "simple" && (
//                         <Editor
//                             editorContent={editorContent}
//                             onChange={setEditorContent}
//                         /> 
//                ) }

//                { editorMode === "advanced" && (
//                 <EmailEditorTest setEditorContent={setEditorContent} editorContent={editorContent} handleAdvancedEditorContent={handleAdvancedEditorContent}  ref={editorRef}/>

//                )}

//                     </Box>
//                 )}

//                 {currentStep === 1 && (
//                     <Box
//                         sx={{
//                             width: "100%",
//                             height: "24rem",
//                             border: 1,
//                             flex: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             borderColor: "#bbbcbd",
//                             paddingTop: "0.75rem",
//                             paddingLeft: "2rem",
//                             paddingRight: "0.75rem",
//                             paddingBottom: "2rem",
//                         }}
//                     >
//                         <CustomizedDrawer
//                             message={"Proceed without any attachments?"}
//                             drawerOpen={drawerOpen}
//                             closeDrawer={closeDrawer}
//                             onCancel={() => setDrawerOpen(false)}
//                         />
//                         <Box
//                             sx={{
//                                 display: "flex",
//                                 justifyContent: "flex-end",
//                                 mb: 1,
//                                 gap: 1,
//                             }}
//                         >
//                             <Button
//                                 variant="contained"
//                                 size="small"
//                                 disabled={files.length === 0 || backdropOpen}
//                                 onClick={handleUploadAttachments}
//                             >
//                                 Upload Attachments
//                                 {backdropOpen ? (
//                                     <CircularProgress
//                                         size={20}
//                                         sx={{
//                                             position: "absolute",
//                                             top: "50%",
//                                             left: "50%",
//                                             marginTop: "-12px",
//                                             marginLeft: "-12px",
//                                         }}
//                                     />
//                                 ) : null}
//                             </Button>
//                             {/* <Button
//                                 variant="contained"
//                                 size="small"
//                                 // disabled={attachmentIds.length === 0}
//                                 onClick={handleSaveContent}
//                             >
//                                 Save
//                             </Button> */}
//                         </Box>

//                         {files.length === 0 && (
//                             <UploadFiles
//                                 title={"Attach Multiple Files"}
//                                 imgSrc={"paper_2.jpg"}
//                                 handleAttachedFiles={handleAttachedFiles}
//                                 acceptType={
//                                     ".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
//                                 }
//                             />
//                         )}

//                         {files.length > 0 && (
//                             <FileTable
//                                 files={files}
//                                 onDelete={onDelete}
//                                 handleEditFiles={handleEditFiles}
//                                 isAttachedFiles={isAttachedFiles}
//                                 acceptType={
//                                     ".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
//                                 }
//                             />
//                         )}
//                         {files.length > 0 && files.length < 5 && (
//                             <Button
//                                 variant="contained"
//                                 component="label"
//                                 sx={{
//                                     mb: 1,
//                                     width: "50%",
//                                     marginLeft: "auto",
//                                     marginRight: "auto",
//                                 }}
//                             >
//                                 Attach more files
//                                 <input
//                                     type="file"
//                                     hidden
//                                     multiple
//                                     accept=".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
//                                     onChange={handleAttachedFiles}
//                                 />
//                             </Button>
//                         )}
//                         <NoticeBox bulletPoints={bulletPoints} />
//                     </Box>
//                 )}
//                 {currentStep === 3 && (
//                     <Box
//                         sx={{
//                             width: "100%",
//                             height: "24rem",
//                             border: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             flex: 1,

//                             borderColor: "#bbbcbd",
//                             paddingTop: "0.75rem",
//                             paddingLeft: "2rem",
//                             paddingRight: "0.75rem",
//                             paddingBottom: "2rem",
//                         }}
//                     >

//                                <Typography variant="h6" gutterBottom sx={{ mb: 2, display:"flex", justifyContent:"center" }}>
//                                         Select Priority for your message
//                                     </Typography>
                        
//                                     {/* Priority Chips */}
//                                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3, justifyContent:"center" }}>
//                                         {priorityChips.map((chip, i) => (
//                                             <Chip
//                                                 key={chip.priorityNumber}
//                                                 label={chip.label}
//                                                 onClick={() => handlePriorityClick(chip.priorityNumber)}
//                                                 sx={{
//                                                     backgroundColor:  i === 0 ? "#013930ff" : teal[(10-i)*100],
//                                                     color: "white",
//                                                     fontWeight: "bold",
//                                                     "&:hover": {
//                                                         backgroundColor: `rgba(25, 118, 210, ${Math.min(chip.opacity + 0.2, 1)})`,
//                                                     },
//                                                     ...(selectedPriority === chip.priorityNumber && {
//                                                         border: "2px solid rgba(8, 105, 21, 1)",
//                                                     })
//                                                 }}
//                                             />
//                                         ))}
//                                     </Box>
//                                        {/* Selected Priority Message */}
//                                     {selectedPriority && (
//                                         <Paper
//                                             sx={{
//                                                 p: 2,
//                                                 mb: 3,
//                                                 backgroundColor: "rgba(25, 118, 210, 0.1)",
//                                                 border: "2px solid rgba(8, 105, 21, 1)",
//                                                 borderRadius: 2,
//                                                 textAlign: "center"
//                                             }}
//                                         >
//                                             <Typography variant="h6" sx={{color:"rgba(8, 105, 21, 1)"}} fontWeight="bold">
//                                                 You selected priority number {selectedPriority}
//                                             </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                                                 This message will be sent with {selectedPriority === 1 ? "highest" : "high"} priority
//                                             </Typography>
//                                         </Paper>
//                                     )}
                        


//                         {emailFile.length == 0 && (
//                             <>
//                                 <Box
//                                     sx={{
//                                         width: "100%",
//                                         display: "flex",
//                                         justifyContent: "center",
//                                         gap: 1,
//                                         mb: 2,
//                                     }}
//                                 >
//                                     <TextField
//                                         variant="outlined"
//                                         sx={{ width: "50%" }}
//                                         label="Email Id(s)"
//                                         placeholder="user1@example.com,user2@example.com"
//                                         size="small"
//                                         onChange={handleManualEmailChange}
//                                     />
//                                     {/* <Button
//                                         variant="contained"
//                                         size="small"
//                                         onClick={handleManualEmailAdd}
//                                     >
//                                         Add
//                                     </Button> */}
//                                 </Box>
//                             </>
//                         )}

//                         {!manualEmail && emailFile.length === 0 && (
//                             <Typography
//                                 sx={{
//                                     fontSize: "1rem",
//                                     fontWeight: "800",
//                                     textAlign: "center",
//                                 }}
//                             >
//                                 OR
//                             </Typography>
//                         )}
//                         {/* <Box
//                             sx={{ display: "flex", justifyContent: "flex-end" }}
//                         >
//                             <Button
//                                 variant="contained"
//                                 size="small"
//                                 disabled={emailFile.length === 0}
//                             >
//                                 Upload
//                             </Button>
//                         </Box> */}

//                         {emailFile.length === 0 && !manualEmail && (
//                             <>
//                                 <UploadFiles
//                                     title={"Choose Excel File"}
//                                     imgSrc={"Wavy_Bus-06_Single-06.jpg"}
//                                     handleAttachedFiles={handleEmailAttach}
//                                     acceptType={".xlsx, .xls"}
//                                 />
//                                 {/* <Typography sx={{ textAlign: "center" }}>
//                                     OR Enter comma separated emails
//                                 </Typography> */}
//                             </>
//                         )}

//                         {(emailFile.length > 0 || manualEmail) && (
//                             <>
//                                 <FileTable
//                                     files={emailFile}
//                                     onDelete={handleDeleteCsv}
//                                     isAttachedFiles={isAttachedFiles}
//                                     handleEditFiles={handleCsvFileEdit}
//                                     acceptType={".xlsx, .xls"}
//                                 />

//                                 <ScheduleDialog selectDate={setDate} />
//                                 <Box
//                                     sx={{
//                                         width: "50%",
//                                         color: "red",
//                                         marginRight: "auto",
//                                         marginLeft: "auto",
//                                         textAlign: "end",
//                                         mt: 1,
//                                     }}
//                                 >
//                                     Scheduled Date & Time : {date}
//                                 </Box>
//                             </>
//                         )}
//                         <NoticeBox bulletPoints={csvFilePoints} />
//                     </Box>
//                 )}
//             </Box>

//             <Box
//                 sx={{
//                     width: "100%",
//                     mt: 1,
//                     gap: 2,
//                     flexDirection: "row-reverse",
//                     display: "flex",
//                 }}
//             >
//                 {currentStep !== 2 && currentStep !== 1 && (
//                     <Button
//                         variant="contained"
//                         onClick={handleNextStep}
//                         size="small"
//                     >
//                         <NavigateNextSharp fontSize="small" />
//                     </Button>
//                 )}
//                 {currentStep === 1 && (
//                     <Button
//                         variant="contained"
//                         onClick={handleSaveContent}
//                         size="small"
//                         disabled={saveLoading}
//                     >
//                         Save & Next
//                         {saveLoading ? (
//                             <CircularProgress
//                                 size={20}
//                                 sx={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "50%",
//                                     marginTop: "-12px",
//                                     marginLeft: "-12px",
//                                 }}
//                             />
//                         ) : null}
//                     </Button>
//                 )}
//                 {currentStep === 3 && (
//                     <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={handleFinalSubmit}
//                         size="small"
//                         disabled={!date || backdropOpen}
//                     >
//                         Confirm
//                         {backdropOpen ? (
//                             <CircularProgress
//                                 size={20}
//                                 sx={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "50%",
//                                     marginTop: "-12px",
//                                     marginLeft: "-12px",
//                                 }}
//                             />
//                         ) : null}
//                     </Button>
//                 )}
//                 {currentStep !== 0 && (
//                     <Button
//                         variant="contained"
//                         onClick={handleBackStep}
//                         size="small"
//                     >
//                         <ChevronLeft fontSize="small" />
//                     </Button>
//                 )}
//             </Box>
//         </Box>
//     );
// };

// export default EmailSchedule;









// import React, { useCallback, useEffect, useState, useRef } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import {
//     Box,
//     Button,
//     Chip,
//     formControlClasses,
//     Input,
//     Paper,
//     TextField,
//     Typography,
//     Switch,
//     FormControlLabel,
// } from "@mui/material";
// import {
//     ChevronLeft,
//     NavigateNextSharp,
//     Upload,
// } from "@mui/icons-material";
// import CustomizedSteppers from "./CustomizedSteppers";
// import FileTable from "./FileTable";
// import NoticeBox from "./NoticeBox";
// import UploadFiles from "./UploadFiles";
// import axiosInstance from "../../api/axiosInstance";
// import useNotification from "../common/Notification";
// import isValidate from "../../utils/validation";

// import { csvFilePoints, bulletPoints } from "../../utils/constants";
// import debounce from "../../utils/debounce";
// import ScheduleDialog from "./ScheduleDialog";
// import CustomizedDrawer from "./CustomizedDrawer";
// import { CircularProgress } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { teal } from "@mui/material/colors";

// const EmailSchedule = () => {
//     const [subject, setSubject] = useState("");
//     const [currentStep, setCurrentStep] = useState(0);
//     const [files, setFiles] = useState([]);
//     const [emailFile, setEmailFile] = useState([]);
//     const [isAttachedFiles, setIsAttachedFiles] = useState(true);
//     const [attachmentIds, setAttachmentIds] = useState([]);
//     const [eci, setEci] = useState(null);
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [editorContent, setEditorContent] = useState("");
//     const [backdropOpen, setBackdropOpen] = useState(false);
//     const [skip, setSkip] = useState(true);
//     const [manualEmail, setManualEmail] = useState("");
//     const [saveLoading, setSaveLoading] = useState(false);
//     const [enableHTML, setEnableHTML] = useState(false); // HTML toggle
//     const [templateEditorKey, setTemplateEditorKey] = useState(0);

//     const mailEditorRef = useRef(null);
    
//     // const [open, setOpen] = useState(true);
//     const [date, setDate] = useState("");
//     const notify = useNotification();
//     const navigate = useNavigate();
//   const [selectedPriority, setSelectedPriority] = useState(null);

//     // Generate 10 priority chips with decreasing opacity
//     const priorityChips = Array.from({ length: 10 }, (_, index) => {
//         const priorityNumber = index + 1;
//         const opacity = 1 - (index * 0.09); // Decreasing opacity from 1 to 0.1
//         const backgroundColor = `rgba(0, 128, 128, ${opacity})`
//         return {
//             priorityNumber,
//             opacity,
//             backgroundColor,
//             label: `Priority ${priorityNumber}`
//         };
//     });

//     const handlePriorityClick = (priorityNumber) => {
//         setSelectedPriority(priorityNumber);
//     };
//     useEffect(() => {
//         if (files.length === 0) {
//             setSkip(true);
//         }
//     }, [files]);


//     //Back button alert with useEffect

//     useEffect(() => {
//         const handlePopState = (event) => {
//             const confirmed = window.confirm(
//                 "Unsaved data will be lost if you go back."
//             );
//             if (!confirmed) {
//                 // Push the current URL again to cancel the back navigation
//                 window.history.pushState(null, "", window.location.pathname);
//             }
//         };

//         // Add a fake history entry so the user can "go back"
//         window.history.pushState(null, "", window.location.pathname);

//         window.addEventListener("popstate", handlePopState);

//         return () => {
//             window.removeEventListener("popstate", handlePopState);
//         };
//     }, []);

//     //Api functionns
//     //Attaching files api

//     const handleUploadAttachments = async () => {
//         try {
//             if (files.length === 0) {
//                 return;
//             }

//             let totalFileSizeArr = files.map((file) =>
//                 parseFloat((file.size / 1024).toFixed(1))
//             );

//             let totalFileSize = 0;
//             totalFileSizeArr.forEach((num) => {
//                 totalFileSize += num;
//             });

//             console.log(totalFileSize);

//             if (totalFileSize > 25600) {
//                 notify("Total file size exceeded 25 mb.", "error");
//                 return;
//             }

//             const payload = new FormData();
//             files.forEach((file) => {
//                 payload.append("attachments[]", file);
//             });

//             setBackdropOpen(true);

//             const res = await axiosInstance.post(
//                 "/upload/email/attachments",
//                 payload
//             );
//             notify("Files have been uploaded successfully.", "success");
//             if (res.data?.attachment_ids.length > 0) {
//                 const ids = res.data.attachment_ids;
//                 setAttachmentIds([...ids]);
//             }

//             console.log(res);
//         } catch (e) {
//             if (e.status == 409) {
//                 notify(`${e.response?.data?.message}`, "error");
//                 return;
//             }

//             if (e.status === 413) {
//                 notify(`${e.response?.data.message}`, "error");
//                 return;
//             }
//             if (e.status === 422) {
//                 notify(`${e.response?.data.message}`, "error");
//                 return;
//             }
//             notify(`${e.message}`, "error");
//             console.log("Error: ", e);
//         } finally {
//             // loading ended
//             setBackdropOpen(false);
//         }
//     };

//     // Subject change function *******************************************************************
//     // const debouncedSetSubject = useCallback(
//     //     debounce((value) => setSubject(value), 50),
//     //     []
//     // );

//     //Step change functions **********************************************************************
//     const handleNextStep = () => {

//         if (currentStep === 0) {
//             if (
//                 !isValidate("subject", subject.trim()) ||
//                 !isValidate("editorContent", editorContent.trim())
//             ) {
//                 notify("Please select a template to continue.", "error");
//                 return;
//             }
//         }

//         if (currentStep === 1) {
//             const content = mailEditorRef.current?.getActiveHtml?.()?.trim() || editorContent.trim();
//             setEditorContent(content);

//             if (
//                 !isValidate("subject", subject.trim()) ||
//                 !isValidate("editorContent", content)
//             ) {
//                 notify("Some fields are missing.", "error");
//                 return;
//             }
//         }

//         if (currentStep < 3) {
//             setCurrentStep((prev) => prev + 1);
//         }
//         return;
//     };

//     const handleBackStep = () => {
//         if (currentStep > 0) {
//             setCurrentStep((prev) => prev - 1);
//         }
//         return;
//     };

//     // Files functions **************************************************************************
//     const handleAttachedFiles = (e) => {
//         const selectedFiles = e.target?.files;
//         if (!selectedFiles) {
//             return;
//         }
//         const length1 = selectedFiles.length;
//         const length2 = files.length;
//         const totalLength = length1 + length2;

//         if (selectedFiles.length > 5 || totalLength > 5) {
//             notify("Cannot Attach more than 5 files.", "error");
//             return;
//         }

//         setFiles((prev) => [...prev, ...e.target.files]);
//         setSkip(false);
//         console.log(e.target.files);
//     };

//     // const handleAttachSingleFile = (e) => {
//     //     const files = e.target?.files;
//     //     if (!files) {
//     //         return;
//     //     }
//     //     // if(files.)
//     // };

//     const onDelete = (idx) => {
//         setFiles((prev) => prev.filter((_, i) => i != idx));
//         console.log("deleting...");
//     };

//     const handleEditFiles = (e, idx) => {
//         const file = e.target?.files[0];
//         if (!file) return;

//         setFiles((prev) =>
//             prev.map((file, i) => {
//                 if (i === idx) {
//                     console.log(e.target.files);
//                     return e.target.files[0];
//                 }
//                 return file;
//             })
//         );

//         notify("File has been replaced.", "success");
//     };

//     // Email file attachment function *************************************************************
//     const handleEmailAttach = (e) => {
//         const file = e.target?.files;
//         if (!file) return;

//         console.log(file);
//         setEmailFile([...file]);
//     };

//     const handleCsvFileEdit = (e, i) => {
//         const file = e.target?.files;
//         if (!file) return;

//         setEmailFile((prev) => [...file]);
//     };

//     const handleDeleteCsv = (i) => {
//         setEmailFile([]);
//     };
//     const convertTime = (seconds) => {
//         const hrs = Math.floor(seconds / 3600);
//         const mins = Math.floor((seconds % 3600) / 60);
//         const secs = seconds % 60;

//         return `${hrs}h ${mins}m ${secs}s`;
//     };

//     // const handleScheduleLater = () => {};
//     const handleFinalSubmit = async () => {
//         if (manualEmail) {
//             if (!eci) {
//                 notify("Email content has not been saved.", "error");
//                 return;
//             }
//             if (!date) {
//                 notify("Schedule date is not added", "error");
//                 return;
//             }
//             const payload = {
//                 eci: eci,
//                 schedule_date_time: date,
//                 email: manualEmail,
//                 message_priority:selectedPriority
//             };
//             console.log("Payload: ", payload)
//             try {
//                 const res = await axiosInstance.post(
//                     `/upload/emails-manual`,
//                     payload
//                 );

//                 const time = 15;
//                 const count = res.data.data;
//                 console.log(res.data.data);
//                 const estimatedTime = convertTime(15 * count);

//                 notify(
//                     `Email(s) have been queued , Estimated time would be ${estimatedTime}. Redirecting to Email queue in 5 sec... `,
//                     "success"
//                 );
//                 setTimeout(() => {
//                     navigate("/email-queue");
//                 }, 5000);
//                 console.log(res);
//             } catch (e) {
//                 if (e.status == 422) {
//                     console.log(e.response.data);
//                     // return;
//                 }
//                 console.log("Error: ", e);
//                 notify(`${e.response.data.message}`, "error");
//                 let result;
//                 if (e.response.data?.invalid_emails) {
//                     const myArray = e.response.data?.invalid_emails;
//                     result = myArray.join(", ");
//                 }
//                 notify(`${result}`, "error");
//             }
//         } else {
//             try {
//                 const payload = new FormData();
//                 if (emailFile.length === 0) {
//                     notify("Email file not uploaded.", "error");
//                     return;
//                 }
//                 if (!date) {
//                     notify("Please Select date and time.", "error");
//                     return;
//                 }
//                 if (!eci) {
//                     notify("Something went wrong , please try again", "error");
//                     // setCurrentStep(0);
//                     return;
//                 }

//                 payload.append("file", emailFile[0]);
//                 payload.append("eci", eci);
//                 payload.append("schedule_date_time", date);
//                 setBackdropOpen(true);
//                 const res = await axiosInstance.post("/upload/emails", payload);
//                 const time = 15;
//                 const count = res.data.emails_count;
//                 const estimatedTime = convertTime(15 * count);

//                 notify(
//                     `Emails have been queued , Estimated time would be ${estimatedTime}. Redirecting to Email queue in 5 sec... `,
//                     "success"
//                 );
//                 setTimeout(() => {
//                     navigate("/email-queue");
//                 }, 5000);
//                 // console.log(res);
//             } catch (e) {
//                 console.error("Error: ", e);
//                 notify("Something went wrong, please try again.", "error");
//             } finally {
//                 setBackdropOpen(false);
//             }
//         }
//     };

//     // Saving email content in database
//     const handleSaveContent = async () => {
//         try {
//             if (skip) {
//                 setDrawerOpen(true);
//                 return;
//             }
//             if (!subject) {
//                 notify("Subject is missing.", "error");
//                 return;
//             }
//             if (!editorContent) {
//                 notify("Email content is missing", "error");
//                 return;
//             }
//             if (!skip) {
//                 if (attachmentIds.length === 0) {
//                     notify("Please upload file attachment(s).", "error");
//                     return;
//                 }
//             }

//             const newAttachmentId = attachmentIds.join(",");
//             const payload = {
//                 subject: subject,
//                 content: editorContent,
//                 attachment_id: newAttachmentId,
//             };
//             setSaveLoading(true);
//             const res = await axiosInstance.post(
//                 "/emails/content-add",
//                 payload
//             );
//             console.log(res);
//             console.log(payload);
//             setEci(res.data.id);
//             notify("Content has been saved!", "success");
//             setIsAttachedFiles(false);
//             setCurrentStep(3);
//         } catch (e) {
//             console.error("Error: ", e);
//             notify("Error while saving content, please try again.", "error");
//         } finally {
//             //
//             setSaveLoading(false);
//         }
//     };

//     const saveContent = async () => {
//         try {
//             if (!subject) {
//                 notify("Subject is missing.", "error");
//                 return;
//             }
//             if (!editorContent) {
//                 notify("Email content is missing", "error");
//                 return;
//             }
//             const newAttachmentId = attachmentIds.join(",");
//             const payload = {
//                 subject: subject,
//                 content: editorContent,
//                 attachment_id: null,
//             };
//             const res = await axiosInstance.post(
//                 "/emails/content-add",
//                 payload
//             );
//             console.log(res);
//             console.log(payload);
//             setEci(res.data.id);
//             setIsAttachedFiles(false);
//             setCurrentStep(3);
//             notify("Email Content has been saved.", "success");
//         } catch (e) {
//             console.error("Error: ", e);
//         } finally {
//             //
//         }
//     };

//     // Drawer close and call handle save content function
//     const closeDrawer = async () => {
//         console.log("Function is called...");
//         setDrawerOpen(false);
//         console.log(drawerOpen);
//         saveContent();

//         // handleSaveContent();
//     };

//     // Function to handle manual emails
//     const handleManualEmailChange = (e) => {
//         setManualEmail(e.target.value);
//         console.log(e.target.value);
//     };

//     //Function to schedule time for manual emails added
//     const handleManualEmailAdd = () => {};

//     const handleTemplateSelect = ({ subject, content }) => {
//         setSubject(subject);
//         setEditorContent(content);
//         setTemplateEditorKey((prev) => prev + 1);
//         setCurrentStep(1);
//     };
  
//     return (
//         <Box
//             sx={{
//                 width: "100%",
//                 maxWidth: "100%",
//                 minWidth: 0,
//                 mt: 1.5,
//                 pb: 2,
//                 boxSizing: "border-box",
//                 overflowX: "hidden",
//             }}
//         >
//             <Box sx={{ width: "100%", maxWidth: "100%", mb: 2, minWidth: 0, overflowX: "hidden" }}>
//                 <CustomizedSteppers currentStep={currentStep} />
//             </Box>

//             <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, mb: 2, overflowX: "hidden" }}>
//                 {currentStep === 0 && (
//                     <SelectEmailTemplateCards onTemplateSelect={handleTemplateSelect} />
//                 )}

//                 {currentStep === 1 && (
//                     <Box
//                         sx={{
//                             width: "100%",
//                             maxWidth: "100%",
//                             height: "calc(100vh - 200px)",
//                             minHeight: 0,
//                             maxHeight: "calc(100vh - 200px)",
//                             display: "flex",
//                             flexDirection: "column",
//                             overflow: "hidden",
//                             overflowX: "hidden",
//                             pt: 0.5,
//                             boxSizing: "border-box",
//                         }}
//                     >
//                         <EditMailContent
//                             key={templateEditorKey}
//                             ref={mailEditorRef}
//                             subject={subject}
//                             onSubjectChange={setSubject}
//                             initialHtml={editorContent}
//                             onHtmlChange={setEditorContent}
//                         />
//                     </Box>
//                 )}

//                 {currentStep === 2 && (
//                     <Box
//                         sx={{
//                             width: "100%",
//                             maxWidth: "100%",
//                             border: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             borderColor: "#bbbcbd",
//                             paddingTop: "0.75rem",
//                             paddingLeft: "2rem",
//                             paddingRight: "0.75rem",
//                             paddingBottom: "2rem",
//                             boxSizing: "border-box",
//                             overflowX: "hidden",
//                         }}
//                     >
//                         <CustomizedDrawer
//                             message={"Proceed without any attachments?"}
//                             drawerOpen={drawerOpen}
//                             closeDrawer={closeDrawer}
//                             onCancel={() => setDrawerOpen(false)}
//                         />
//                         <Box
//                             sx={{
//                                 display: "flex",
//                                 justifyContent: "flex-end",
//                                 mb: 1,
//                                 gap: 1,
//                             }}
//                         >
//                             <Button
//                                 variant="contained"
//                                 size="small"
//                                 disabled={files.length === 0 || backdropOpen}
//                                 onClick={handleUploadAttachments}
//                             >
//                                 Upload Attachments
//                                 {backdropOpen ? (
//                                     <CircularProgress
//                                         size={20}
//                                         sx={{
//                                             position: "absolute",
//                                             top: "50%",
//                                             left: "50%",
//                                             marginTop: "-12px",
//                                             marginLeft: "-12px",
//                                         }}
//                                     />
//                                 ) : null}
//                             </Button>
//                             {/* <Button
//                                 variant="contained"
//                                 size="small"
//                                 // disabled={attachmentIds.length === 0}
//                                 onClick={handleSaveContent}
//                             >
//                                 Save
//                             </Button> */}
//                         </Box>

//                         {files.length === 0 && (
//                             <UploadFiles
//                                 title={"Attach Multiple Files"}
//                                 imgSrc={"paper_2.jpg"}
//                                 handleAttachedFiles={handleAttachedFiles}
//                                 acceptType={
//                                     ".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
//                                 }
//                             />
//                         )}

//                         {files.length > 0 && (
//                             <FileTable
//                                 files={files}
//                                 onDelete={onDelete}
//                                 handleEditFiles={handleEditFiles}
//                                 isAttachedFiles={isAttachedFiles}
//                                 acceptType={
//                                     ".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
//                                 }
//                             />
//                         )}
//                         {files.length > 0 && files.length < 5 && (
//                             <Button
//                                 variant="contained"
//                                 component="label"
//                                 sx={{
//                                     mb: 1,
//                                     width: { xs: "100%", sm: "50%" },
//                                     maxWidth: "100%",
//                                     marginLeft: "auto",
//                                     marginRight: "auto",
//                                 }}
//                             >
//                                 Attach more files
//                                 <input
//                                     type="file"
//                                     hidden
//                                     multiple
//                                     accept=".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
//                                     onChange={handleAttachedFiles}
//                                 />
//                             </Button>
//                         )}
//                         <NoticeBox bulletPoints={bulletPoints} />
//                     </Box>
//                 )}
//                 {currentStep === 3 && (
//                     <Box
//                         sx={{
//                             width: "100%",
//                             maxWidth: "100%",
//                             border: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             borderColor: "#bbbcbd",
//                             paddingTop: "0.75rem",
//                             paddingLeft: "2rem",
//                             paddingRight: "0.75rem",
//                             paddingBottom: "2rem",
//                             boxSizing: "border-box",
//                             overflowX: "hidden",
//                         }}
//                     >

//                                <Typography variant="h6" gutterBottom sx={{ mb: 2, display:"flex", justifyContent:"center" }}>
//                                         Select Priority for your message
//                                     </Typography>
                        
//                                     {/* Priority Chips */}
//                                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3, justifyContent:"center" }}>
//                                         {priorityChips.map((chip, i) => (
//                                             <Chip
//                                                 key={chip.priorityNumber}
//                                                 label={chip.label}
//                                                 onClick={() => handlePriorityClick(chip.priorityNumber)}
//                                                 sx={{
//                                                     backgroundColor:  i === 0 ? "#013930ff" : teal[(10-i)*100],
//                                                     color: "white",
//                                                     fontWeight: "bold",
//                                                     "&:hover": {
//                                                         backgroundColor: `rgba(25, 118, 210, ${Math.min(chip.opacity + 0.2, 1)})`,
//                                                     },
//                                                     ...(selectedPriority === chip.priorityNumber && {
//                                                         border: "2px solid rgba(8, 105, 21, 1)",
//                                                     })
//                                                 }}
//                                             />
//                                         ))}
//                                     </Box>
//                                        {/* Selected Priority Message */}
//                                     {selectedPriority && (
//                                         <Paper
//                                             sx={{
//                                                 p: 2,
//                                                 mb: 3,
//                                                 backgroundColor: "rgba(25, 118, 210, 0.1)",
//                                                 border: "2px solid rgba(8, 105, 21, 1)",
//                                                 borderRadius: 2,
//                                                 textAlign: "center"
//                                             }}
//                                         >
//                                             <Typography variant="h6" sx={{color:"rgba(8, 105, 21, 1)"}} fontWeight="bold">
//                                                 You selected priority number {selectedPriority}
//                                             </Typography>
//                                             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                                                 This message will be sent with {selectedPriority === 1 ? "highest" : "high"} priority
//                                             </Typography>
//                                         </Paper>
//                                     )}
                        


//                         {emailFile.length == 0 && (
//                             <>
//                                 <Box
//                                     sx={{
//                                         width: "100%",
//                                         display: "flex",
//                                         justifyContent: "center",
//                                         gap: 1,
//                                         mb: 2,
//                                     }}
//                                 >
//                                     <TextField
//                                         variant="outlined"
//                                         sx={{ width: { xs: "100%", sm: "50%" }, maxWidth: "100%" }}
//                                         label="Email Id(s)"
//                                         placeholder="user1@example.com,user2@example.com"
//                                         size="small"
//                                         onChange={handleManualEmailChange}
//                                     />
//                                     {/* <Button
//                                         variant="contained"
//                                         size="small"
//                                         onClick={handleManualEmailAdd}
//                                     >
//                                         Add
//                                     </Button> */}
//                                 </Box>
//                             </>
//                         )}

//                         {!manualEmail && emailFile.length === 0 && (
//                             <Typography
//                                 sx={{
//                                     fontSize: "1rem",
//                                     fontWeight: "800",
//                                     textAlign: "center",
//                                 }}
//                             >
//                                 OR
//                             </Typography>
//                         )}
//                         {/* <Box
//                             sx={{ display: "flex", justifyContent: "flex-end" }}
//                         >
//                             <Button
//                                 variant="contained"
//                                 size="small"
//                                 disabled={emailFile.length === 0}
//                             >
//                                 Upload
//                             </Button>
//                         </Box> */}

//                         {emailFile.length === 0 && !manualEmail && (
//                             <>
//                                 <UploadFiles
//                                     title={"Choose Excel File"}
//                                     imgSrc={"Wavy_Bus-06_Single-06.jpg"}
//                                     handleAttachedFiles={handleEmailAttach}
//                                     acceptType={".xlsx, .xls"}
//                                 />
//                                 {/* <Typography sx={{ textAlign: "center" }}>
//                                     OR Enter comma separated emails
//                                 </Typography> */}
//                             </>
//                         )}

//                         {(emailFile.length > 0 || manualEmail) && (
//                             <>
//                                 <FileTable
//                                     files={emailFile}
//                                     onDelete={handleDeleteCsv}
//                                     isAttachedFiles={isAttachedFiles}
//                                     handleEditFiles={handleCsvFileEdit}
//                                     acceptType={".xlsx, .xls"}
//                                 />

//                                 <ScheduleDialog selectDate={setDate} />
//                                 <Box
//                                     sx={{
//                                         width: "50%",
//                                         color: "red",
//                                         marginRight: "auto",
//                                         marginLeft: "auto",
//                                         textAlign: "end",
//                                         mt: 1,
//                                     }}
//                                 >
//                                     Scheduled Date & Time : {date}
//                                 </Box>
//                             </>
//                         )}
//                         <NoticeBox bulletPoints={csvFilePoints} />
//                     </Box>
//                 )}
//             </Box>

//             <Box
//                 sx={{
//                     width: "100%",
//                     mt: 1,
//                     gap: 2,
//                     flexDirection: "row-reverse",
//                     display: "flex",
//                 }}
//             >
//                 {currentStep !== 2 && currentStep !== 3 && (
//                     <Button
//                         variant="contained"
//                         onClick={handleNextStep}
//                         size="small"
//                     >
//                         <NavigateNextSharp fontSize="small" />
//                     </Button>
//                 )}
//                 {currentStep === 2 && (
//                     <Button
//                         variant="contained"
//                         onClick={handleSaveContent}
//                         size="small"
//                         disabled={saveLoading}
//                     >
//                         Save & Next
//                         {saveLoading ? (
//                             <CircularProgress
//                                 size={20}
//                                 sx={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "50%",
//                                     marginTop: "-12px",
//                                     marginLeft: "-12px",
//                                 }}
//                             />
//                         ) : null}
//                     </Button>
//                 )}
//                 {currentStep === 3 && (
//                     <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={handleFinalSubmit}
//                         size="small"
//                         disabled={!date || backdropOpen}
//                     >
//                         Confirm
//                         {backdropOpen ? (
//                             <CircularProgress
//                                 size={20}
//                                 sx={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "50%",
//                                     marginTop: "-12px",
//                                     marginLeft: "-12px",
//                                 }}
//                             />
//                         ) : null}
//                     </Button>
//                 )}
//                 {currentStep !== 0 && (
//                     <Button
//                         variant="contained"
//                         onClick={handleBackStep}
//                         size="small"
//                     >
//                         <ChevronLeft fontSize="small" />
//                     </Button>
//                 )}
//             </Box>
//         </Box>
//     );
// };

// export default EmailSchedule;






            










import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import {
    Box,
    Button,
    Chip,
    Paper,
    TextField,
    Typography,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Alert,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
} from "@mui/material";
import {
    ChevronLeft,
    NavigateNextSharp,
} from "@mui/icons-material";
import CustomizedSteppers from "./CustomizedSteppers";
import FileTable from "./FileTable";
import NoticeBox from "./NoticeBox";
import UploadFiles from "./UploadFiles";
import axiosInstance from "../../api/axiosInstance";
import axios from "axios";
import base_url from "../../constants";
import useNotification from "../common/Notification";
import isValidate from "../../utils/validation";

import { csvFilePoints, bulletPoints } from "../../utils/constants";
import {
    buildExcelVariableNoticePoints,
    buildTemplateApiParamFields,
    extractEmailMergeVariables,
    validateEmailMergeParameters,
} from "../../utils/emailMergeVariables";
import { normalizeEmailHtmlForEditor } from "../../utils/normalizeEmailHtml";
import debounce from "../../utils/debounce";
import ScheduleDialog from "./ScheduleDialog";
import CustomizedDrawer from "./CustomizedDrawer";
import { useNavigate } from "react-router-dom";
import { teal } from "@mui/material/colors";
import Cookies from "js-cookie";

const EmailSchedule = () => {
    const [subject, setSubject] = useState("");
    const [selectedTemplateName, setSelectedTemplateName] = useState("");
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [files, setFiles] = useState([]);
    const [emailFile, setEmailFile] = useState([]);
    const [isAttachedFiles, setIsAttachedFiles] = useState(true);
    const [attachmentIds, setAttachmentIds] = useState([]);
    const [eci, setEci] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editorContent, setEditorContent] = useState("");
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [skip, setSkip] = useState(true);
    const [manualEmail, setManualEmail] = useState("");
    const [saveLoading, setSaveLoading] = useState(false);
    const [enableHTML, setEnableHTML] = useState(false); // HTML toggle
    const [templateEditorKey, setTemplateEditorKey] = useState(0);
    const [templateListKey, setTemplateListKey] = useState(0);
    const [senders, setSenders] = useState([]);
    const [sendersLoading, setSendersLoading] = useState(false);
    const [selectedSenderId, setSelectedSenderId] = useState("");
    const [saveTemplateDialogOpen, setSaveTemplateDialogOpen] = useState(false);
    const [editedTemplateName, setEditedTemplateName] = useState("");
    const [pendingStepContent, setPendingStepContent] = useState("");
    const [templateSaveLoading, setTemplateSaveLoading] = useState(false);
    const [contentDirty, setContentDirty] = useState(false);

    const mailEditorRef = useRef(null);
    const originalSubjectRef = useRef("");
    
    // const [open, setOpen] = useState(true);
    const [date, setDate] = useState("");
    const notify = useNotification();
    const navigate = useNavigate();
  const [selectedPriority, setSelectedPriority] = useState(null);

    const selectedSender = senders.find(
        (s) => String(s.id) === String(selectedSenderId)
    );

    const templateVariables = useMemo(
        () => extractEmailMergeVariables(subject, editorContent),
        [subject, editorContent]
    );

    const excelNoticePoints = useMemo(
        () =>
            templateVariables.length > 0
                ? buildExcelVariableNoticePoints(templateVariables)
                : csvFilePoints,
        [templateVariables]
    );

    // Generate 10 priority chips with decreasing opacity
    const priorityChips = Array.from({ length: 10 }, (_, index) => {
        const priorityNumber = index + 1;
        const opacity = 1 - (index * 0.09); // Decreasing opacity from 1 to 0.1
        const backgroundColor = `rgba(0, 128, 128, ${opacity})`
        return {
            priorityNumber,
            opacity,
            backgroundColor,
            label: `Priority ${priorityNumber}`
        };
    });

    const handlePriorityClick = (priorityNumber) => {
        setSelectedPriority(priorityNumber);
    };
    useEffect(() => {
        if (files.length === 0) {
            setSkip(true);
        }
    }, [files]);

    const fetchSenders = useCallback(async () => {
        setSendersLoading(true);
        try {
            const { data } = await axiosInstance.get("/email-business/sender-emails", {
                headers: { Accept: "application/json" },
            });
            const rows = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data)
                  ? data
                  : [];
            setSenders(
                rows.map((item) => ({
                    id: item.id,
                    sender_email: item.sender_email_id || item.email || "",
                    reply_email: item.reply_to || "",
                }))
            );
        } catch (error) {
            setSenders([]);
            notify(
                error.response?.data?.message ||
                    error.response?.data?.error ||
                    "Failed to load sender emails",
                "error"
            );
        } finally {
            setSendersLoading(false);
        }
    }, [notify]);

    useEffect(() => {
        if (currentStep === 3) {
            fetchSenders();
        }
    }, [currentStep, fetchSenders]);


    //Back button alert with useEffect

    useEffect(() => {
        const handlePopState = (event) => {
            const confirmed = window.confirm(
                "Unsaved data will be lost if you go back."
            );
            if (!confirmed) {
                // Push the current URL again to cancel the back navigation
                window.history.pushState(null, "", window.location.pathname);
            }
        };

        // Add a fake history entry so the user can "go back"
        window.history.pushState(null, "", window.location.pathname);

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    //Api functionns
    //Attaching files api

    const handleUploadAttachments = async () => {
        try {
            if (files.length === 0) {
                return;
            }

            let totalFileSizeArr = files.map((file) =>
                parseFloat((file.size / 1024).toFixed(1))
            );

            let totalFileSize = 0;
            totalFileSizeArr.forEach((num) => {
                totalFileSize += num;
            });

            console.log(totalFileSize);

            if (totalFileSize > 25600) {
                notify("Total file size exceeded 25 mb.", "error");
                return;
            }

            const payload = new FormData();
            files.forEach((file) => {
                payload.append("attachments[]", file);
            });

            setBackdropOpen(true);

            const res = await axiosInstance.post(
                "/upload/email/attachments",
                payload
            );
            notify("Files have been uploaded successfully.", "success");
            if (res.data?.attachment_ids.length > 0) {
                const ids = res.data.attachment_ids;
                setAttachmentIds([...ids]);
            }

            console.log(res);
        } catch (e) {
            if (e.status == 409) {
                notify(`${e.response?.data?.message}`, "error");
                return;
            }

            if (e.status === 413) {
                notify(`${e.response?.data.message}`, "error");
                return;
            }
            if (e.status === 422) {
                notify(`${e.response?.data.message}`, "error");
                return;
            }
            notify(`${e.message}`, "error");
            console.log("Error: ", e);
        } finally {
            // loading ended
            setBackdropOpen(false);
        }
    };

    // Subject change function *******************************************************************
    // const debouncedSetSubject = useCallback(
    //     debounce((value) => setSubject(value), 50),
    //     []
    // );

    //Step change functions **********************************************************************
    const goToNextStep = () => {
        if (currentStep < 4) {
            setCurrentStep((prev) => prev + 1);
        }
    };

    const openSaveTemplateDialog = () => {
        setEditedTemplateName(subject.trim() || selectedTemplateName || "");
        setSaveTemplateDialogOpen(true);
    };

    const getLatestEditorContent = () => {
        const synced =
            mailEditorRef.current?.syncAndGetHtml?.() ||
            mailEditorRef.current?.getActiveHtml?.();
        const content = String(synced || pendingStepContent || editorContent || "").trim();
        if (content) {
            setEditorContent(content);
        }
        return content;
    };

    const handleSubjectChange = (value) => {
        setSubject(value);
    };

    const handleEditorHtmlChange = (html) => {
        setEditorContent(html);
    };

    const handleEditorUserEdit = () => {
        setContentDirty(true);
    };

    const handleNextStep = () => {
        if (currentStep === 0) {
            if (
                !isValidate("subject", subject.trim()) ||
                !isValidate("editorContent", editorContent.trim())
            ) {
                notify("Please select a template to continue.", "error");
                return;
            }
        }

        if (currentStep === 1) {
            const content = getLatestEditorContent();

            if (
                !isValidate("subject", subject.trim()) ||
                !isValidate("editorContent", content)
            ) {
                notify("Some fields are missing.", "error");
                return;
            }

            const paramError = validateEmailMergeParameters(subject, content);
            if (paramError) {
                notify(paramError, "error");
                return;
            }

            const subjectChanged =
                subject.trim() !== originalSubjectRef.current.trim();
            // contentDirty is set only by real editor edits (not template load / blur / mode switch).
            if (contentDirty || subjectChanged) {
                openSaveTemplateDialog();
                return;
            }
        }

        goToNextStep();
    };

    const handleSkipSaveTemplate = () => {
        setSaveTemplateDialogOpen(false);
        setPendingStepContent("");
        setContentDirty(false);
        goToNextStep();
    };

    const handleConfirmSaveTemplate = async () => {
        const title = editedTemplateName.trim() || subject.trim();
        const content = getLatestEditorContent();

        if (!selectedTemplateId) {
            notify("Template ID missing. Please select the template again.", "error");
            return;
        }

        if (!title) {
            notify("Please enter a template name.", "error");
            return;
        }

        if (!content) {
            notify("Email content is missing.", "error");
            return;
        }

        const paramError = validateEmailMergeParameters(subject, content);
        if (paramError) {
            notify(paramError, "error");
            return;
        }

        const payload = {
            template_id: selectedTemplateId,
            user_id: Cookies.get("userId"),
            role: Cookies.get("userRole"),
            title,
            type: "0",
            template: content,
            template_design: null,
            ...buildTemplateApiParamFields(content),
        };

        try {
            setTemplateSaveLoading(true);
            const token = Cookies.get("token");
            await axios.post(`${base_url}/email-template/update`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
            });
            notify("Template updated successfully.", "success");
            setSaveTemplateDialogOpen(false);
            setPendingStepContent("");
            setSubject(title);
            setSelectedTemplateName(title);
            originalSubjectRef.current = title;
            setContentDirty(false);
            setTemplateListKey((prev) => prev + 1);
            goToNextStep();
        } catch (error) {
            console.error("Error updating template:", error);
            notify(
                error.response?.data?.message || "Failed to update template.",
                "error"
            );
        } finally {
            setTemplateSaveLoading(false);
        }
    };

    const handleBackStep = () => {
        if (currentStep > 0) {
            setCurrentStep((prev) => prev - 1);
        }
        return;
    };

    // Files functions **************************************************************************
    const handleAttachedFiles = (e) => {
        const selectedFiles = e.target?.files;
        if (!selectedFiles) {
            return;
        }
        const length1 = selectedFiles.length;
        const length2 = files.length;
        const totalLength = length1 + length2;

        if (selectedFiles.length > 5 || totalLength > 5) {
            notify("Cannot Attach more than 5 files.", "error");
            return;
        }

        setFiles((prev) => [...prev, ...e.target.files]);
        setSkip(false);
        console.log(e.target.files);
    };

    // const handleAttachSingleFile = (e) => {
    //     const files = e.target?.files;
    //     if (!files) {
    //         return;
    //     }
    //     // if(files.)
    // };

    const onDelete = (idx) => {
        setFiles((prev) => prev.filter((_, i) => i != idx));
        console.log("deleting...");
    };

    const handleEditFiles = (e, idx) => {
        const file = e.target?.files[0];
        if (!file) return;

        setFiles((prev) =>
            prev.map((file, i) => {
                if (i === idx) {
                    console.log(e.target.files);
                    return e.target.files[0];
                }
                return file;
            })
        );

        notify("File has been replaced.", "success");
    };

    // Email file attachment function *************************************************************
    const handleEmailAttach = (e) => {
        const file = e.target?.files;
        if (!file) return;

        console.log(file);
        setManualEmail("");
        setEmailFile([...file]);
    };

    const handleCsvFileEdit = (e, i) => {
        const file = e.target?.files;
        if (!file) return;

        setManualEmail("");
        setEmailFile([...file]);
    };

    const handleDeleteCsv = (i) => {
        setEmailFile([]);
    };
    const convertTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        return `${hrs}h ${mins}m ${secs}s`;
    };

    // Confirm: Excel → POST /upload/emails ; Manual typed emails → POST /upload/emails-manual
    const handleFinalSubmit = async () => {
        const useExcelUpload = emailFile.length > 0;

        if (!useExcelUpload && manualEmail?.trim()) {
            if (!eci) {
                notify("Email content has not been saved.", "error");
                return;
            }
            if (!date) {
                notify("Schedule date is not added", "error");
                return;
            }
            const payload = {
                eci,
                schedule_date_time: date,
                email: manualEmail.trim(),
            };
            if (selectedPriority != null) {
                payload.priority_number = selectedPriority;
            }
            if (selectedSender?.sender_email) {
                payload.sender_email = selectedSender.sender_email;
            }
            if (selectedSender?.reply_email) {
                payload.reply_email = selectedSender.reply_email;
            }
            console.log("Payload: ", payload)
            try {
                const res = await axiosInstance.post(
                    `/upload/emails-manual`,
                    payload
                );

                const count = res.data.data;
                console.log(res.data.data);
                const estimatedTime = convertTime(15 * count);

                notify(
                    `Email(s) have been queued , Estimated time would be ${estimatedTime}. Redirecting to Email queue in 5 sec... `,
                    "success"
                );
                setTimeout(() => {
                    navigate("/email-queue");
                }, 5000);
                console.log(res);
            } catch (e) {
                if (e.status == 422) {
                    console.log(e.response.data);
                }
                console.log("Error: ", e);
                notify(`${e.response?.data?.message || "Upload failed"}`, "error");
                if (e.response?.data?.invalid_emails) {
                    notify(e.response.data.invalid_emails.join(", "), "error");
                }
            }
            return;
        }

        try {
            if (emailFile.length === 0) {
                notify("Email file not uploaded.", "error");
                return;
            }
            if (!date) {
                notify("Please Select date and time.", "error");
                return;
            }
            if (!eci) {
                notify("Something went wrong , please try again", "error");
                return;
            }
            if (templateVariables.length > 0 && !selectedTemplateName) {
                notify(
                    "Template name is missing. Go back and select the template again so parameters can be applied.",
                    "error"
                );
                return;
            }

            const payload = new FormData();
            payload.append("file", emailFile[0]);
            payload.append("eci", eci);
            payload.append("schedule_date_time", date);
            if (selectedTemplateName) {
                payload.append("template_name", selectedTemplateName);
            }
            if (selectedSender?.sender_email) {
                payload.append("sender_email", selectedSender.sender_email);
            }
            if (selectedSender?.reply_email) {
                payload.append("reply_email", selectedSender.reply_email);
            }
            if (selectedPriority != null) {
                payload.append("priority_number", selectedPriority);
            }

            console.log("Excel upload → POST /upload/emails", {
                file: emailFile[0]?.name,
                eci,
                schedule_date_time: date,
                template_name: selectedTemplateName || null,
                priority_number: selectedPriority,
            });

            setBackdropOpen(true);
            const res = await axiosInstance.post("/upload/emails", payload);
            const count = res.data.emails_count;
            const estimatedTime = convertTime(15 * count);

            notify(
                `Emails have been queued , Estimated time would be ${estimatedTime}. Redirecting to Email queue in 5 sec... `,
                "success"
            );
            setTimeout(() => {
                navigate("/email-queue");
            }, 5000);
        } catch (e) {
            console.error("Excel upload error: ", e);
            const data = e.response?.data;
            const missing = data?.missing_columns;
            let message =
                data?.message ||
                data?.error ||
                "Something went wrong, please try again.";
            if (Array.isArray(missing) && missing.length > 0) {
                message = `${message} Missing columns: ${missing.join(", ")}`;
            }
            notify(message, "error");
        } finally {
            setBackdropOpen(false);
        }
    };

    // Saving email content in database
    const handleSaveContent = async () => {
        try {
            if (skip) {
                setDrawerOpen(true);
                return;
            }
            if (!subject) {
                notify("Subject is missing.", "error");
                return;
            }
            if (!editorContent) {
                notify("Email content is missing", "error");
                return;
            }

            const paramError = validateEmailMergeParameters(subject, editorContent);
            if (paramError) {
                notify(paramError, "error");
                return;
            }

            if (!skip) {
                if (attachmentIds.length === 0) {
                    notify("Please upload file attachment(s).", "error");
                    return;
                }
            }

            const newAttachmentId = attachmentIds.join(",");
            const payload = {
                subject: subject,
                content: editorContent,
                attachment_id: newAttachmentId,
            };
            setSaveLoading(true);
            const res = await axiosInstance.post(
                "/emails/content-add",
                payload
            );
            console.log(res);
            console.log(payload);
            setEci(res.data.id);
            notify("Content has been saved!", "success");
            setIsAttachedFiles(false);
            setCurrentStep(3);
        } catch (e) {
            console.error("Error: ", e);
            notify("Error while saving content, please try again.", "error");
        } finally {
            //
            setSaveLoading(false);
        }
    };

    const saveContent = async () => {
        try {
            if (!subject) {
                notify("Subject is missing.", "error");
                return;
            }
            if (!editorContent) {
                notify("Email content is missing", "error");
                return;
            }

            const paramError = validateEmailMergeParameters(subject, editorContent);
            if (paramError) {
                notify(paramError, "error");
                return;
            }

            const newAttachmentId = attachmentIds.join(",");
            const payload = {
                subject: subject,
                content: editorContent,
                attachment_id: null,
            };
            const res = await axiosInstance.post(
                "/emails/content-add",
                payload
            );
            console.log(res);
            console.log(payload);
            setEci(res.data.id);
            setIsAttachedFiles(false);
            setCurrentStep(3);
            notify("Email Content has been saved.", "success");
        } catch (e) {
            console.error("Error: ", e);
        } finally {
            //
        }
    };

    // Drawer close and call handle save content function
    const closeDrawer = async () => {
        console.log("Function is called...");
        setDrawerOpen(false);
        console.log(drawerOpen);
        saveContent();

        // handleSaveContent();
    };

    // Function to handle manual emails
    const handleManualEmailChange = (e) => {
        setManualEmail(e.target.value);
        console.log(e.target.value);
    };

    //Function to schedule time for manual emails added
    const handleManualEmailAdd = () => {};

    const handleTemplateSelect = ({ subject, content, templateName, templateId }) => {
        const normalizedContent = normalizeEmailHtmlForEditor(content);
        setSubject(subject);
        setEditorContent(normalizedContent);
        originalSubjectRef.current = (subject || "").trim();
        setContentDirty(false);
        setSelectedTemplateName(templateName || "");
        setSelectedTemplateId(templateId || null);
        setTemplateEditorKey((prev) => prev + 1);
        setCurrentStep(1);
    };
  
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                mt: 1.5,
                pb: 2,
                boxSizing: "border-box",
                overflowX: "hidden",
            }}
        >
            {currentStep === 0 && (
                <Box sx={{ width: "100%", maxWidth: "100%", mb: 2, minWidth: 0 }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 800,
                            color: "text.primary",
                            mb: 0.5,
                        }}
                    >
                        Select Template
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        Choose a template from the list below to start your email campaign.
                    </Typography>
                </Box>
            )}

            <Box sx={{ width: "100%", maxWidth: "100%", mb: 2, minWidth: 0, overflowX: "hidden" }}>
                <CustomizedSteppers currentStep={currentStep} />
            </Box>

            <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, mb: 2, overflowX: "hidden" }}>
                {currentStep === 0 && (
                    <SelectEmailTemplateTable
                        key={templateListKey}
                        onTemplateSelect={handleTemplateSelect}
                    />
                )}

                {currentStep === 1 && (
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            height: "calc(100vh - 200px)",
                            minHeight: 0,
                            maxHeight: "calc(100vh - 200px)",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            overflowX: "hidden",
                            pt: 0.5,
                            boxSizing: "border-box",
                        }}
                    >
                        <EditMailContent
                            key={templateEditorKey}
                            ref={mailEditorRef}
                            subject={subject}
                            onSubjectChange={handleSubjectChange}
                            initialHtml={editorContent}
                            onHtmlChange={handleEditorHtmlChange}
                            onUserEdit={handleEditorUserEdit}
                        />
                    </Box>
                )}

                {currentStep === 2 && (
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            border: 1,
                            display: "flex",
                            flexDirection: "column",
                            borderColor: "#bbbcbd",
                            paddingTop: "0.75rem",
                            paddingLeft: "2rem",
                            paddingRight: "0.75rem",
                            paddingBottom: "2rem",
                            boxSizing: "border-box",
                            overflowX: "hidden",
                        }}
                    >
                        <CustomizedDrawer
                            message={"Proceed without any attachments?"}
                            drawerOpen={drawerOpen}
                            closeDrawer={closeDrawer}
                            onCancel={() => setDrawerOpen(false)}
                        />
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                mb: 1,
                                gap: 1,
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                disabled={files.length === 0 || backdropOpen}
                                onClick={handleUploadAttachments}
                            >
                                Upload Attachments
                                {backdropOpen ? (
                                    <CircularProgress
                                        size={20}
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            marginTop: "-12px",
                                            marginLeft: "-12px",
                                        }}
                                    />
                                ) : null}
                            </Button>
                            {/* <Button
                                variant="contained"
                                size="small"
                                // disabled={attachmentIds.length === 0}
                                onClick={handleSaveContent}
                            >
                                Save
                            </Button> */}
                        </Box>

                        {files.length === 0 && (
                            <UploadFiles
                                title={"Attach Multiple Files"}
                                imgSrc={"paper_2.jpg"}
                                handleAttachedFiles={handleAttachedFiles}
                                acceptType={
                                    ".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
                                }
                            />
                        )}

                        {files.length > 0 && (
                            <FileTable
                                files={files}
                                onDelete={onDelete}
                                handleEditFiles={handleEditFiles}
                                isAttachedFiles={isAttachedFiles}
                                acceptType={
                                    ".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
                                }
                            />
                        )}
                        {files.length > 0 && files.length < 5 && (
                            <Button
                                variant="contained"
                                component="label"
                                sx={{
                                    mb: 1,
                                    width: { xs: "100%", sm: "50%" },
                                    maxWidth: "100%",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                }}
                            >
                                Attach more files
                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    accept=".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
                                    onChange={handleAttachedFiles}
                                />
                            </Button>
                        )}
                        <NoticeBox bulletPoints={bulletPoints} />
                    </Box>
                )}
                {currentStep === 3 && (
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            border: 1,
                            display: "flex",
                            flexDirection: "column",
                            borderColor: "#bbbcbd",
                            paddingTop: "0.75rem",
                            paddingLeft: "2rem",
                            paddingRight: "0.75rem",
                            paddingBottom: "2rem",
                            boxSizing: "border-box",
                            overflowX: "hidden",
                        }}
                    >
                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{ mb: 2, display: "flex", justifyContent: "center" }}
                        >
                            Select From Email for your message (optional)
                        </Typography>

                        {sendersLoading ? (
                            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                                <CircularProgress size={24} />
                            </Box>
                        ) : (
                            <>
                                {senders.length === 0 && (
                                    <Alert
                                        severity="info"
                                        sx={{ mb: 2, mx: "auto", maxWidth: 520, width: "100%" }}
                                    >
                                        No sender emails configured. You can continue without
                                        selecting one, or create one under Manage Email Senders.
                                    </Alert>
                                )}
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        mb: 2,
                                    }}
                                >
                                    <FormControl
                                        size="small"
                                        sx={{
                                            width: { xs: "100%", sm: "50%" },
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <InputLabel id="campaign-from-email-label">
                                            From Email
                                        </InputLabel>
                                        <Select
                                            labelId="campaign-from-email-label"
                                            label="From Email"
                                            value={selectedSenderId}
                                            onChange={(e) => setSelectedSenderId(e.target.value)}
                                        >
                                            <MenuItem value="">
                                                <em>None (use default sender)</em>
                                            </MenuItem>
                                            {senders.map((sender) => (
                                                <MenuItem
                                                    key={sender.id}
                                                    value={String(sender.id)}
                                                >
                                                    {sender.sender_email}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>

                                {selectedSender && (
                                    <Paper
                                        sx={{
                                            p: 2,
                                            mb: 1,
                                            mx: "auto",
                                            width: { xs: "100%", sm: "50%" },
                                            maxWidth: "100%",
                                            backgroundColor: "rgba(25, 118, 210, 0.1)",
                                            border: "2px solid rgba(8, 105, 21, 1)",
                                            borderRadius: 2,
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ color: "rgba(8, 105, 21, 1)" }}
                                            fontWeight="bold"
                                        >
                                            From: {selectedSender.sender_email}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ mt: 1 }}
                                        >
                                            Reply-To:{" "}
                                            {selectedSender.reply_email || "Not set"}
                                        </Typography>
                                    </Paper>
                                )}
                            </>
                        )}
                    </Box>
                )}
                {currentStep === 4 && (
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            border: 1,
                            display: "flex",
                            flexDirection: "column",
                            borderColor: "#bbbcbd",
                            paddingTop: "0.75rem",
                            paddingLeft: "2rem",
                            paddingRight: "0.75rem",
                            paddingBottom: "2rem",
                            boxSizing: "border-box",
                            overflowX: "hidden",
                        }}
                    >
                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{ mb: 2, display: "flex", justifyContent: "center" }}
                        >
                            Select Priority for your message
                        </Typography>

                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2,
                                mb: 3,
                                justifyContent: "center",
                            }}
                        >
                            {priorityChips.map((chip, i) => (
                                <Chip
                                    key={chip.priorityNumber}
                                    label={chip.label}
                                    onClick={() => handlePriorityClick(chip.priorityNumber)}
                                    sx={{
                                        backgroundColor:
                                            i === 0 ? "#013930ff" : teal[(10 - i) * 100],
                                        color: "white",
                                        fontWeight: "bold",
                                        "&:hover": {
                                            backgroundColor: `rgba(25, 118, 210, ${Math.min(
                                                chip.opacity + 0.2,
                                                1
                                            )})`,
                                        },
                                        ...(selectedPriority === chip.priorityNumber && {
                                            border: "2px solid rgba(8, 105, 21, 1)",
                                        }),
                                    }}
                                />
                            ))}
                        </Box>

                        {selectedPriority && (
                            <Paper
                                sx={{
                                    p: 2,
                                    mb: 3,
                                    backgroundColor: "rgba(25, 118, 210, 0.1)",
                                    border: "2px solid rgba(8, 105, 21, 1)",
                                    borderRadius: 2,
                                    textAlign: "center",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{ color: "rgba(8, 105, 21, 1)" }}
                                    fontWeight="bold"
                                >
                                    You selected priority number {selectedPriority}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ mt: 1 }}
                                >
                                    This message will be sent with{" "}
                                    {selectedPriority === 1 ? "highest" : "high"} priority
                                </Typography>
                            </Paper>
                        )}

                        {emailFile.length == 0 && (
                            <>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: 1,
                                        mb: 2,
                                    }}
                                >
                                    <TextField
                                        variant="outlined"
                                        sx={{
                                            width: { xs: "100%", sm: "50%" },
                                            maxWidth: "100%",
                                        }}
                                        label="Email Id(s)"
                                        placeholder="user1@example.com,user2@example.com"
                                        size="small"
                                        onChange={handleManualEmailChange}
                                    />
                                </Box>
                            </>
                        )}

                        {!manualEmail && emailFile.length === 0 && (
                            <Typography
                                sx={{
                                    fontSize: "1rem",
                                    fontWeight: "800",
                                    textAlign: "center",
                                }}
                            >
                                OR
                            </Typography>
                        )}

                        {emailFile.length === 0 && !manualEmail && (
                            <>
                                <UploadFiles
                                    title={"Choose Excel File"}
                                    imgSrc={"Wavy_Bus-06_Single-06.jpg"}
                                    handleAttachedFiles={handleEmailAttach}
                                    acceptType={".xlsx, .xls"}
                                />
                            </>
                        )}

                        {(emailFile.length > 0 || manualEmail) && (
                            <>
                                <FileTable
                                    files={emailFile}
                                    onDelete={handleDeleteCsv}
                                    isAttachedFiles={isAttachedFiles}
                                    handleEditFiles={handleCsvFileEdit}
                                    acceptType={".xlsx, .xls"}
                                />

                                <ScheduleDialog selectDate={setDate} />
                                <Box
                                    sx={{
                                        width: "50%",
                                        color: "red",
                                        marginRight: "auto",
                                        marginLeft: "auto",
                                        textAlign: "end",
                                        mt: 1,
                                    }}
                                >
                                    Scheduled Date & Time : {date}
                                </Box>
                            </>
                        )}
                        <NoticeBox bulletPoints={excelNoticePoints} />
                    </Box>
                )}
            </Box>

            <Box
                sx={{
                    width: "100%",
                    mt: 1,
                    gap: 2,
                    flexDirection: "row-reverse",
                    display: "flex",
                }}
            >
                {currentStep !== 2 && currentStep !== 4 && (
                    <Button
                        variant="contained"
                        onClick={handleNextStep}
                        size="small"
                        disabled={
                            (currentStep === 3 && sendersLoading) ||
                            templateSaveLoading
                        }
                    >
                        <NavigateNextSharp fontSize="small" />
                    </Button>
                )}
                {currentStep === 2 && (
                    <Button
                        variant="contained"
                        onClick={handleSaveContent}
                        size="small"
                        disabled={saveLoading}
                    >
                        Save & Next
                        {saveLoading ? (
                            <CircularProgress
                                size={20}
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-12px",
                                    marginLeft: "-12px",
                                }}
                            />
                        ) : null}
                    </Button>
                )}
                {currentStep === 4 && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleFinalSubmit}
                        size="small"
                        disabled={
                            !date ||
                            backdropOpen ||
                            (emailFile.length === 0 && !manualEmail?.trim())
                        }
                    >
                        Confirm
                        {backdropOpen ? (
                            <CircularProgress
                                size={20}
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-12px",
                                    marginLeft: "-12px",
                                }}
                            />
                        ) : null}
                    </Button>
                )}
                {currentStep !== 0 && (
                    <Button
                        variant="contained"
                        onClick={handleBackStep}
                        size="small"
                    >
                        <ChevronLeft fontSize="small" />
                    </Button>
                )}
            </Box>

            <Dialog
                open={saveTemplateDialogOpen}
                onClose={() => !templateSaveLoading && setSaveTemplateDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Save template changes?</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        You edited this template. Do you want to update the
                        template with your changes, or continue without saving?
                    </DialogContentText>
                    <TextField
                        autoFocus
                        fullWidth
                        size="small"
                        label="Template name"
                        value={editedTemplateName}
                        onChange={(e) => setEditedTemplateName(e.target.value)}
                        disabled={templateSaveLoading}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        onClick={handleSkipSaveTemplate}
                        disabled={templateSaveLoading}
                        color="inherit"
                    >
                        Skip
                    </Button>
                    <Button
                        onClick={handleConfirmSaveTemplate}
                        variant="contained"
                        disabled={templateSaveLoading}
                    >
                        {templateSaveLoading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            "Update Template"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default EmailSchedule;






            